export default {
	getById(id, cb, ecb, config) {
		this.http
			.get(`/staff/getById/${id}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getByIds(ids, cb, ecb, config) {
		this.http
			.get(`/staff/getByIds/${ids}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/staff/update', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/staff/search/', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	status(id, to, cb, ecb, config) {
		this.http
			.get(`/staff/status/${id}/${to}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	tip(form, cb, ecb) {
		this.http
			.post('/staff/tip', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchTipOrder(params, cb, ecb) {
		this.http
			.get('/staff/searchTipOrder/', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	addToShop(uid, shopid, cb, ecb) {
		this.http
			.get(`/staff/addToShop/${uid}/${shopid}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	removeFromShop(staffid, shopid, cb, ecb) {
		this.http
			.get(`/staff/removeFromShop/${staffid}/${shopid}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
